export default "__VITE_ASSET__YQbIL5fj__"